import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { StaticImage } from 'gatsby-plugin-image';

import { BackToTopWrapper, ScrollUpButton } from './styles';

interface BackToTopProps {
  label?: string;
}

const BackToTop = ({
  label,
}: BackToTopProps) => {
  const intl = useIntl();
  const title = label || (intl.locale === 'fr' ? 'Remonter' : 'Back up');
  const [visible, setVisible] = useState(false);
  const [pageHeight, setPageHeight] = useState(1000);

  // Set page depth for when button appears
  useEffect(() => {
    setPageHeight(document.body.scrollHeight * 0.2);
  }, []);

  // Smooth scroll to top of page when button is clicked
  const scrollToTop = () => {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }
  };

  useEffect(() => {
    // Trigger button to be visible once page depth is reach and hide before
    const toggleVisible = () => {
      const scrolled = document.documentElement.scrollTop;

      if (scrolled > pageHeight) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisible);

    return () => window.removeEventListener('scroll', toggleVisible);
  }, [pageHeight]);

  return (
    <BackToTopWrapper>
      <ScrollUpButton
        visible={visible}
        onClick={(e) => {
          e.preventDefault();
          scrollToTop();
          // Set short timeout to enable browser to add focus back to the top
          setTimeout(
            () => document.getElementById('gatsby-focus-wrapper').focus(),
            300,
          );
        }}
        aria-label={
          intl.locale === 'fr'
            ? 'Retour en haut de page'
            : 'Back to top of page'
        }
      >
        <StaticImage
          src="../../../images/back-to-top.svg"
          alt=""
          role="presentation"
          className="backUpArrow"
        />
        <p>{title}</p>
      </ScrollUpButton>
    </BackToTopWrapper>
  );
};

export default BackToTop;
